import { getImageLoading, isOrHandleAsExternalUrl } from "../../../helpers";
import type { TImage, TLink, TIndexableBlock } from "../../../types";
import { PrimaryButtonLink } from "../../elements/button/button";
import Heading from "../../elements/heading/heading";
import styles from "./banner-block.module.less";

export type TBannerBlockProps = {
  eyebrow?: string;
  heading: string;
  text?: string;
  link?: TLink;
  image?: TImage;
} & TIndexableBlock;

export const BannerBlock = ({ eyebrow, heading, text, link, image, index }: TBannerBlockProps) => {
  return (
    <section className={[styles.section].join(" ")}>
      <div className={["padded-sides max-width", styles.innerWrapper].join(" ")}>
        <div className={styles.contentWrapper}>
          <div className={styles.imageWrapper}>
            {image?.url && <img src={image.url} alt={image.alt} loading={getImageLoading(index)} />}
          </div>
          <div className={styles.textWrapper}>
            {eyebrow && <p className={`${styles.eyebrow} eyebrow`}>{eyebrow}</p>}
            <Heading semanticType={"h2"} visualType={"h4"} index={index} className={[styles.heading].join(" ")}>
              {heading}
            </Heading>
            {text && <p>{text}</p>}
            {link && (
              <PrimaryButtonLink
                iconRight={"ui-icon-arrow-right"}
                label={link.title}
                url={link?.url}
                openInNewTab={isOrHandleAsExternalUrl(link.url, link.target)}
                onPreNavigate={link.onPreNavigate}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerBlock;
